import React, { useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { RoomLayout } from "../layout/RoomLayout";
import { useResizeViewport } from "./useResizeViewport";
import { TranscriptionProvider } from "../transcription/TranscriptionContext";
import { createMetaverseTranscriptionHostAdapter } from "../transcription/transcription-metaverse-host-adapter";

export function RoomLayoutContainer({ store, scene, performConditionalSignIn, transcriptionHostAdapter, ...rest }) {
  const viewportRef = useRef();
  const resolvedTranscriptionHostAdapter = useMemo(() => {
    if (transcriptionHostAdapter) {
      return transcriptionHostAdapter;
    }

    return createMetaverseTranscriptionHostAdapter({ app: APP, store });
  }, [store, transcriptionHostAdapter]);

  useResizeViewport(viewportRef, store, scene);

  return (
    <TranscriptionProvider entered={Boolean(rest.entered)} hostAdapter={resolvedTranscriptionHostAdapter}>
      <RoomLayout
        viewportRef={viewportRef}
        scene={scene}
        store={store}
        performConditionalSignIn={performConditionalSignIn}
        {...rest}
      />
    </TranscriptionProvider>
  );
}

RoomLayoutContainer.propTypes = {
  store: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  performConditionalSignIn: PropTypes.func,
  transcriptionHostAdapter: PropTypes.object
};
